import {SET_FAQ_QUERY, CLEAR_FAQ_QUERY} from '../constants/ActionTypes';

export function setFaqQuery(query) {
    return {
        type: SET_FAQ_QUERY, 
        payload: {
            query: query
        }
    };
}

export function clearFaqQuery() {
    return {
        type: CLEAR_FAQ_QUERY, 
        payload: {
            query: ''
        }
    };
}
